export enum PaymentIntervalEnum {
  DAILY = "DAILY",
  WEEKLY = "WEEKLY",
  BI_WEEKLY = "BI_WEEKLY",
  MONTHLY = "MONTHLY",
}

export enum WorkPaymentSourceEnum {
  COMMON_CASH_OUT_UI = "COMMON_CASH_OUT_UI",
  WEEKLY_PAYMENT_UI = "WEEKLY_PAYMENT_UI",
  WORK_ADD_API = "WORK_ADD_API",
}

export interface DeductionDto {
  welfare?: number;
  otherDeduction?: number;
}

export interface WeeklyPreFetchItemDto {
  workerId: number;
  openingBalance: number;
  totalWage: number;
  totalOvertime: number;
  workCount: number;
  noOfDaysWorked: number;
  welfareAmount: number;
  advancePaid: number;
  hasExistingPayment: boolean;
}

export interface WeeklyPreFetchResponseDto {
  items: WeeklyPreFetchItemDto[];
}

export interface CreateWeeklyWorkPaymentItemDto {
  workerId: number;
  openingBalance: number;
  noOfDays?: number;
  totalWage: number;
  totalOvertime?: number;
  advancePaid?: number;
  deduction?: DeductionDto;
  paymentAmount: number;
  closingBalance: number;
}

export interface CreateWeeklyWorkPaymentDto {
  startDate: string;
  endDate: string;
  interval: PaymentIntervalEnum;
  date: string;
  source: WorkPaymentSourceEnum;
  projectId?: number;
  projectStageId?: number;
  description?: string;
  isPaid?: boolean;
  fromAccountId?: number;
  companyId?: number;
  items: CreateWeeklyWorkPaymentItemDto[];
}

export interface WorkPaymentDto {
  id: number;
  workerId: number;
  date: string;
  startDate?: string;
  endDate?: string;
  interval?: PaymentIntervalEnum;
  sessionId?: string;
  source: WorkPaymentSourceEnum;
  projectId?: number;
  projectStageId?: number;
  description?: string;
  openingBalance: number;
  noOfDays?: number;
  totalWage: number;
  totalOvertime?: number;
  advancePaid?: number;
  deduction?: DeductionDto;
  paymentAmount: number;
  closingBalance: number;
  isPaid?: boolean;
  fromAccountId?: number;
  transactionId?: number;
  worker?: { id: number; name: string; accountId?: number };
}

// UI-local row shape used by the CrudTable in AddBulkWorkerPaymentForm.
// Maps 1:1 to CreateWeeklyWorkPaymentItemDto, keyed by the CrudTable's `id`.
export interface WeeklyWorkerRow {
  id: number; // workerId, used as the DataGrid row id
  workerId: number;
  name: string;
  paymentId?: number; // WorkPayment.id, present only in edit mode
  transactionId?: number; // present once this row has been paid; locks money fields
  balance: number; // openingBalance
  workHours?: number; // noOfDays, pre-filled from noOfDaysWorked (unique dates worked in the range)
  workCount?: number; // total count of work entries added in the range (informational, not sent to the API)
  totalWorked: number; // totalWage
  overtime?: number; // totalOvertime
  advancePaid?: number;
  welfare?: number; // deduction.welfare
  deduction?: number; // deduction.otherDeduction
  amountToPay: number; // paymentAmount
  closingBalance: number; // derived, not sent as edited input
  hasExistingPayment?: boolean; // a WorkPayment already exists for this worker in the selected range
  disabled?: boolean; // CrudTable convention: blocks editing/entering edit mode for this row
  disabledReason?: string; // CrudTable convention: tooltip shown for a disabled row
}
